import { useLayoutEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import birdFlight from "../../images/royal-mahal/bird-flight.webp";
import { saveBirdHandoff } from "./art/birdHandoff";
import "./styles/loader.scss";

const FONTS = "https://fonts.googleapis.com/css2?family=Lora:ital,wght@1,500&display=swap";

/**
 * The loader every theme shows while the invite is fetched (themes/registry.js): one of
 * Royal Mahal's birds flying in place on parchment. It uses the same sprite strip as the
 * birds in Royal Mahal's sky (art/flight.js). On a Royal Mahal invite the gate then picks
 * the bird up where the loader left it (art/birdHandoff.js); other themes ignore that.
 */
const RoyalLoader = () => {
  const bird = useRef(null);
  const wings = useRef(null);
  const text = useRef(null);

  // As the loader goes, note where the bird and the caption were so the gate can pick up from there
  useLayoutEffect(() => {
    const birdEl = bird.current;
    const wingsEl = wings.current;
    const textEl = text.current;
    return () => {
      if (!birdEl || !wingsEl) return;
      const r = birdEl.getBoundingClientRect();
      if (!r.width) return;
      const t = textEl && textEl.getBoundingClientRect();
      saveBirdHandoff({
        x: r.left + r.width / 2,
        y: r.top + r.height / 2,
        w: r.width,
        frame: (parseFloat(getComputedStyle(wingsEl).backgroundPositionX) || 0) / 100,
        text: t && { left: t.left, top: t.top, width: t.width, label: textEl.textContent },
      });
    };
  }, []);

  return (
    <div className="rm-loader" role="status" aria-live="polite">
      <Helmet>
        <link rel="stylesheet" href={FONTS} />
      </Helmet>
      <div ref={bird} className="rm-loader__bird" aria-hidden="true">
        <div ref={wings} className="rm-loader__wings" style={{ backgroundImage: `url(${birdFlight})` }} />
      </div>
      <p ref={text} className="rm-loader__text">
        Taking you to the invitation
      </p>
    </div>
  );
};

export default RoyalLoader;
